<template>
    <div class="row no-row-padding">
        <div class="tabs col-md-12">
            <ul class="nav nav-tabs nav-justified flex-column flex-md-row" role="tablist_map">
                <li class="nav-item">
                    <a class="nav-link active" id="gallery-tab" data-toggle="tab" href="#gallery" role="tab" aria-controls="gallery" aria-selected="true">
                        <i class="far fa-images"></i> <strong>{{ $t('components.mapsTabs.images') }}</strong>
                    </a>
                </li>
                <li v-if="hasVR" class="nav-item">
                    <a class="nav-link" id="virtualtour-tab" data-toggle="tab" href="#virtualtour" role="tab" aria-controls="virtualtour" aria-selected="false">
                        <i class="far fa-eye"></i> <strong>Virtual Tour 360º</strong>
                    </a>
                </li>
                <li v-if="hasDocuments" class="nav-item">
                    <a class="nav-link" id="files-tab" data-toggle="tab" href="#files" role="tab" aria-controls="files" aria-selected="false">
                        <i class="far fas fa-file-pdf"></i> <strong>{{ $t('components.mapsTabs.documents') }}</strong>
                    </a>
                </li>
                <li v-if="hasYoutube" class="nav-item">
                    <a class="nav-link" id="youtube-tab" data-toggle="tab" href="#youtube" role="tab" aria-controls="youtube" aria-selected="false">
                        <i class="fas fa-video"></i> <strong>Video</strong>
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <!-- START GALLERY -->
                <div v-if="true" id="gallery" class="tab-pane active" role="tabpanel" aria-labelledby="gallery-tab">
                        <!-- Replaced Galleria with Vue Gallery Component -->
                        <GalleryComponent :mainImages="computeDataInput()" :vrUrl="vr" />
                </div>

                <!-- VR EMBED -->
                <div v-if="hasVR" id="virtualtour" class="tab-pane" role="tabpanel" aria-labelledby="virtualtour-tab" style="max-height: 600px;height: 60vh;">
                    <iframe width='100%' height='100%' :src="vr" frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                </div>

                <!-- DOCUMENTS TAB -->
                <div v-if="hasDocuments" class="tab-pane" id="files" role="tabpanel" aria-labelledby="files-tab">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="featured-boxes featured-boxes-style-5">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-lg-3" v-for="file in files" :key="file.filename" @click="downloadFile(file)" style="cursor: pointer">
                                        <div class="featured-box featured-box-secondary featured-box-effect-3" style="height: 115px;margin-top: 15px !important; margin-bottom: 15px !important;">
                                            <div class="box-content">
                                                <i class="icon-featured far fa-file"></i>
                                                <h4>{{ file.friendlyFilename }}</h4>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- YOUTUBE TAB -->
                <div v-if="hasYoutube" class="tab-pane" id="youtube" role="tabpanel" aria-labelledby="youtube-tab" style="max-height: 600px;height: 60vh;">
                    <iframe width="100%" height="100%" :src="`https://www.youtube.com/embed/${youtubeVideoId}`" frameborder="0" allow="autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import GalleryComponent from './GalleryComponent.vue';

export default {
    name: 'GalleryTabs',
    components: {
        GalleryComponent,
    },
    props: {
        images: {
            type: Array,
            default: function() {
                return [];
            }
        },
        files: {
            type: Array,
            default: function() {
                return [];
            }
        },
        vr: {
            type: String,
            default: undefined
        },
        youtubeVideoId: {
            type: String,
            default: undefined
        }
    },
    methods: {
        switchTo360: function() {
            $("#virtualTourSelector").click();
        },
        computeDataInput: function() {
            return this.images.map(el => {
                return {
                    thumb: `${this.STATIC_ASSETS_URL}/${el.thumb.filename}`,
                    image: `${this.STATIC_ASSETS_URL}/${el.small.filename}`,
                    big: `${this.STATIC_ASSETS_URL}/${el.full.filename}`,
                }
            })
        },
        isDefined: function(value) {
            return value !== undefined && value !== null && value.trim() !== "";
        },
        downloadFile: function(file) {
            let axiosSettings = {
                method: 'GET',
                url: `${this.staticFileUrl}/${file.filename}`,
                responseType: 'blob'
            };

            console.log("File downloaded:" + file)

            let contentType = file.contentType;

            this.$http(axiosSettings).then(response => {
                const blob = new Blob([response.data], { type: contentType })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.setAttribute('download', file.friendlyFilename);
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },
    },
    computed: {
        hasDocuments: function() {
            return this.files.length > 0;
        },
        hasVR: function() {
            return this.isDefined(this.vr);
        },
        hasPictures: function() {
            return this.images.length > 0;
        },
        hasYoutube: function() {
            return this.isDefined(this.youtubeVideoId);
        }
    },
    data() {
        return {
            staticFileUrl: process.env.VUE_APP_STATIC_FILES_URL
        }
    }
}
</script>


<style scoped lang="scss">
.tab-content {
    padding: 0;
}

.vr-button {
  width: 100%;
  height: 100%;
  padding: 10px;
  padding-top: 25px;
  border-radius: 50%;
  line-height: 60px;
  vertical-align: middle;
  color: white;
}
.vr-button:hover {
  text-decoration: none;
  color: white;
}

.vr-button-container {
  height: 60px;
  width: 60px;
  padding: 0px !important;
  text-align: center;
  display: table-cell;
  cursor: pointer;
}

.nav-link.active {
            border-top-color: $primary-color !important;
}

.nav-tabs.nav-justified li .nav-link {
  border-bottom: none;
}

.nav-link.active.show {
  background-color: white;
}

.nav-link > i {
  padding-right: 5px !important;
}

</style>